import capitalize from "lodash/capitalize";
import { dateDiff, durationFormat } from "@stadium/helpers/dayjs";

import { GLOBAL_POINT_PAYMENT_KEY, MY_WALLET_PAYMENT_KEY } from "@stadium/constants/wallets";

const ORDER_EDITABLE_TIME_LIMIT_IN_SECONDS = 3600;
const emptyObj = {};

export const formatTimer = (seconds) => {
  if (seconds >= 3600) return durationFormat(seconds, "seconds", "H[h] m[m]");
  else if (seconds >= 60) return durationFormat(seconds, "seconds", "m[m]");
  return durationFormat(seconds, "seconds", "s[s]");
};

export const getRemainingOrderExpiryTime = (orderCompletedAt) => {
  const remainingSeconds =
    ORDER_EDITABLE_TIME_LIMIT_IN_SECONDS - dateDiff(new Date(), orderCompletedAt, "seconds");
  return remainingSeconds > 0 ? remainingSeconds : 0;
};

export const getPaymentMethod = (paymentsDetails, cardDetails) => {
  let paymentMethod = "";
  paymentsDetails?.forEach((paymentObj) => {
    const { paymentType } = paymentObj;
    switch (paymentType) {
      case MY_WALLET_PAYMENT_KEY:
        return;
      case GLOBAL_POINT_PAYMENT_KEY:
        return;
      case "corporate_bill":
        paymentMethod += "Corporate Billing";
        break;
      case "stripe_gateway": {
        const { ccType, lastDigits } = cardDetails || emptyObj;
        if (ccType) paymentMethod += `${capitalize(ccType)} ending in ${lastDigits}`;
        break;
      }
    }
  });
  return paymentMethod;
};

export const getWalletPayments = (payments, isCustomCurrencyShop) => {
  const walletPayment = payments
    .filter((payment) => payment.paymentType === MY_WALLET_PAYMENT_KEY)
    .reduce((acc, payment) => acc + +payment.amount, 0);

  const stadiumPointsPayment =
    +payments.find((payment) => payment.paymentType === GLOBAL_POINT_PAYMENT_KEY)?.[
      isCustomCurrencyShop ? "originalAmount" : "amount"
    ] || 0;

  return { walletPayment, stadiumPointsPayment };
};
